// ============================================================
// api/m365Lifecycle.js
// Admin endpoint bindings for Platform-03 (Federated M365 Identity
// Lifecycle). Tenant-scoped, admin-tenant only.
//
// Backend reference:
//   backend/func-carehub-api/src/functions/admin-tenants-m365-lifecycle-consent-url.js
//   APIM op: mgmt-admin-tenants-m365-consent-url
// ============================================================

import { apiPost } from './client';

/**
 * Generate the admin-consent URL for the Identity Lifecycle app reg that a
 * client tenant's Global Administrator clicks. Built server-side from
 * M365_LIFECYCLE_APP_REG_CLIENT_ID + the Tenant's ExternalTenantID + the
 * MANDATORY explicit redirect_uri (api-domain callback) + state=TenantID
 * (the 2026-07-24 ruling — a bare URL lets Entra pick any registered URI,
 * and a wrong state fails the callback's correlation).
 *
 * Throws ApiError(404 tenant_not_found) if the Tenant doesn't exist.
 * Throws ApiError(409 tenant_has_no_external_tenant_id) if the Tenants row
 *   has no client M365 tenant GUID recorded.
 * Throws ApiError(500 m365_lifecycle_app_reg_not_configured) if the reg
 *   client id env var is unset.
 *
 * @param {number} tenantId  Tenants.TenantID
 * @returns {Promise<{ tenantId: number, tenantName: string,
 *   externalTenantId: string, consentUrl: string, note: string }>}
 */
export async function generateM365LifecycleConsentUrl(tenantId) {
  return apiPost(`/mgmt/admin/tenants/${tenantId}/m365-lifecycle/consent-url`, {});
}
